import { Box, useToast } from "@chakra-ui/react";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import Form from "./Form";
import { useRef, useState } from "react";
import { createNewVendor } from "../../../actions/inventory/vendor.action";
import { useNavigate } from "react-router-dom";
import vendorValidationSchema from "./validation.jsx";

const AddVendor = () => {
  const [data, setData] = useState({
    vendorType: "",
    vendorContacts: [], 
    vendorStatus: "under_review" 
  });
  const toast = useToast();
  const navigate = useNavigate();
  const formRef = useRef();

  const handleSubmit = async (values) => {
    // console.log("=== ADD VENDOR SUBMIT ===");
    // console.log("Submitting form with values:", values);
    
    try {
      const myformData = new FormData(formRef.current);

      // console.log("Form Data Entries (raw):", [...myformData.entries()]);

      // ✅ Clear vendorContacts from FormData (prevent duplicates)
      myformData.delete("vendorContacts");

      // ✅ Add all form values (except vendorContacts)
      Object.keys(values).forEach((key) => {
        if (key === "vendorContacts") {
          return; // Skip, handle separately
        }
        if (values[key] !== undefined && values[key] !== null && values[key] !== "") {
          myformData.set(key, values[key]);
        }
      });

      // ✅ Handle vendor contacts based on vendor type
      if (values.vendorType === "organisation") {
        // Filter out completely empty contacts
        const validContacts = (values.vendorContacts || []).filter(
          contact => {
            const hasName = contact.name && contact.name.trim() !== "";
            const hasEmail = contact.email && contact.email.trim() !== "";
            const hasMobile = contact.mobile && contact.mobile.trim() !== "";
            return hasName || hasEmail || hasMobile;
          }
        );
        
        // console.log("Valid Contacts (filtered):", validContacts);
        
        // Send contacts (even if empty array)
        myformData.append("vendorContacts", JSON.stringify(validContacts));
      } else {
        // For individual vendors, send empty array
        myformData.append("vendorContacts", JSON.stringify([]));
      }

      // console.log("=== Final FormData ===");
      // for (let [k, v] of myformData.entries()) {
      //   console.log(k, ":", v instanceof File ? `[File: ${v.name}]` : v);
      // }

      const res = await createNewVendor(myformData);

      toast({
        title: "Success",
        description: "Vendor added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right"
      });

      navigate("/fleet-management/vendor");
    } catch (error) {
      console.error("Error creating vendor:", error);
      toast({
        title: "Error",
        description: error.response?.data?.message || error.message || "Failed to add vendor",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right"
      });
    }
  };

  return (
    <Box w={"100%"} justifyContent={"center"} spacing={10} p={6}>
      <BreadCrumbMaker
        items={[
          { link: "", title: "Fleet Management" },
          { link: "/fleet-management/vendor", title: "Vendor" },
          { link: "", title: "Add Vendor", on: true },
        ]}
      />
      <Form
        data={data}
        setData={setData}
        handleSubmit={handleSubmit}
        formRef={formRef}
        validationSchema={vendorValidationSchema}
      />
    </Box>
  );
};

export default AddVendor;



